module.exports = __webpack_public_path__ + "img/2.658dd9de.svg";